/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSocialFollowResponse
 */
export interface EarnSocialFollowResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EarnSocialFollowResponse
     */
    claimed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EarnSocialFollowResponse
     */
    alreadyClaimed: boolean;
    /**
     * 
     * @type {string}
     * @memberof EarnSocialFollowResponse
     */
    platform: string;
}

/**
 * Check if a given object implements the EarnSocialFollowResponse interface.
 */
export function instanceOfEarnSocialFollowResponse(value: object): value is EarnSocialFollowResponse {
    if (!('claimed' in value) || value['claimed'] === undefined) return false;
    if (!('alreadyClaimed' in value) || value['alreadyClaimed'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function EarnSocialFollowResponseFromJSON(json: any): EarnSocialFollowResponse {
    return EarnSocialFollowResponseFromJSONTyped(json, false);
}

export function EarnSocialFollowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSocialFollowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimed': json['claimed'],
        'alreadyClaimed': json['alreadyClaimed'],
        'platform': json['platform'],
    };
}

export function EarnSocialFollowResponseToJSON(json: any): EarnSocialFollowResponse {
    return EarnSocialFollowResponseToJSONTyped(json, false);
}

export function EarnSocialFollowResponseToJSONTyped(value?: EarnSocialFollowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimed': value['claimed'],
        'alreadyClaimed': value['alreadyClaimed'],
        'platform': value['platform'],
    };
}

